<template>
  <div class="verses-quotes-container">
    <div class="mb-7 mt-12">
      <v-text-field
        v-model="verseQuoteText"
        :label="$t('unitBuilder.versesQuotes.verseLabel')"
        :placeholder="$t('unitBuilder.versesQuotes.versePlaceholder')"
        hide-details="auto"
        color="green"
        variant="outlined"
        class="mb-7 mt-7"
        style="min-width: 100%"
      ></v-text-field>
      <v-text-field
        v-model="verseQuoteReference"
        :label="$t('unitBuilder.versesQuotes.referenceLabel')"
        :placeholder="$t('unitBuilder.versesQuotes.referencePlaceholder')"
        hide-details="auto"
        color="green"
        variant="outlined"
        class="mb-7"
        style="min-width: 100%"
      ></v-text-field>
      <div class="text-center">
        <v-btn
          color="#cfebae"
          class="elevation-0 font-weight-bold"
          @click="addVerseQuote"
          >{{ $t('unitBuilder.versesQuotes.addVerseQuote') }}</v-btn
        >
      </div>
      <v-alert
        v-if="verseQuoteFeedback"
        border="start"
        color="#592892"
        class="text-center mt-7"
      >
        {{ verseQuoteFeedback }}
      </v-alert>
      <v-divider v-if="versesquotes.length" class="mt-10"></v-divider>
    </div>
    <v-expansion-panels
      v-model="openedVersesQuotesPanels"
      variant="accordion"
      tile
      class="pt-0 pb-0"
      :style="{ background: this.$vuetify.theme.dark ? '#1e1e1e' : '#ffffff' }"
    >
      <draggable
        v-model="versesquotes"
        handle=".handle"
        @start="drag = true"
        @end="drag = false"
        @change="updatePositions"
        :tag="'div'"
        item-key="id"
      >
        <template #item="{ element, index }">
          <v-expansion-panel
            :value="index"
            :key="element.id"
            elevation="1"
            class="mb-3"
          >
            <div class="expansion-panel-header-container">
              <div class="handle"><v-icon>drag_icon</v-icon></div>
              <span class="panel-header font-weight-bold">{{
                element.verseQuoteText
              }}</span>
              <div class="action-icons">
                <v-icon @click.native="togglePanel(index)">edit</v-icon>
                <v-icon @click.native="deleteItem(element)">delete_icon</v-icon>
              </div>
            </div>
            <v-expansion-panel-text class="pl-5 pr-5">
              <v-text-field
                v-model="element.verseQuoteText"
                :label="$t('unitBuilder.versesQuotes.verseLabel')"
                hide-details="auto"
                color="green"
                class="mb-7"
                variant="underlined"
                @update:model-value="onQuestionChange(element, index)"
                style="min-width: 100%"
              />
              <v-text-field
                v-model="element.verseQuoteReference"
                :label="$t('unitBuilder.versesQuotes.referenceLabel')"
                hide-details="auto"
                color="green"
                class="mb-7"
                variant="underlined"
                @update:model-value="onQuestionChange(element, index)"
                style="min-width: 100%"
              />
            </v-expansion-panel-text>
          </v-expansion-panel>
        </template>
      </draggable>
    </v-expansion-panels>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import { confirmAction } from '@/components/utilities/SwalService'
  import { matchesConfirmWord } from '@/helpers/confirmWord'

  export default {
    name: 'VersesQuotes',
    props: ['section', 'backdoor', 'unitbackdoor', 'currentLang', 'data'],
    data() {
      return {
        verseQuoteFeedback: null,
        openedVersesQuotesPanels: null, // used to [0]
        versesquotes: [],
        verseQuoteReference: '',
        verseQuoteText: '',
      }
    },
    components: {
      draggable,
    },
    watch: {
      backdoor: function (newVal, oldVal) {
        // watch it
        // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
        if (newVal > oldVal) this.clearComponent()
      },
      unitbackdoor: function (newVal, oldVal) {
        // watch it
        // console.log('unitbackdoor changed: ', newVal, ' | was: ', oldVal)
        if (newVal > oldVal) this.init()
      },
      // Watch for language changes
      currentLang: function (newLang, oldLang) {
        if (newLang !== oldLang) {
          this.loadLanguageData()
        }
      },
      // Watch for data changes from parent
      data: {
        handler: function (newData) {
          // If data is an array (even if empty), use it
          // If undefined/null, set to empty array (don't keep old data)
          if (newData && Array.isArray(newData)) {
            this.versesquotes = [...newData]
          } else {
            this.versesquotes = []
          }
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      loadLanguageData() {
        // Load data for the current language
        // If data is an array (even if empty), use it
        // If undefined/null, use empty array (don't check localStorage for language-aware components)
        if (this.data && Array.isArray(this.data)) {
          this.versesquotes = [...this.data]
        } else {
          this.versesquotes = []
        }
        // Update parent with current state
        this.emitToParent()
      },
      addVerseQuote() {
        this.verseQuoteFeedback = ''
        let verse = this.verseQuoteText
        let reference = this.verseQuoteReference

        if (verse) {
          this.versesquotes.push({
            verseQuoteReference: reference,
            verseQuoteText: verse,
          })

          this.openedVersesQuotesPanels = this.versesquotes.length - 1

          // update the localStorage
          this.addToLocalStorage()

          // clear fields
          this.verseQuoteText = ''
          this.verseQuoteReference = ''
        } else {
          this.verseQuoteFeedback = this.$t('unitBuilder.versesQuotes.needToAddVerse')
        }
      },
      clearComponent() {
        localStorage.removeItem(this.section)

        this.versesquotes = []

        // update parent
        this.emitToParent()
      },
      addToLocalStorage() {
        // update the localStorage
        if (this.versesquotes.length)
          localStorage.setItem(this.section, JSON.stringify(this.versesquotes))
        else localStorage.removeItem(this.section)

        // update parent
        this.emitToParent()
      },
      async deleteItem(item) {
        if (!item) {
          await confirmAction({
            title: this.$t('unitBuilder.versesQuotes.houstonProblem'),
            text: this.$t('unitBuilder.versesQuotes.deleteErrorMissingParams'),
            showCancelButton: false,
            context: this,
            buttonsStyling: false,
            customClass: {
              confirmButton:
                'swal-confirm-btn text-white text-uppercase text-body-2',
              cancelButton:
                'swal-cancel-btn text-white text-uppercase text-body-2',
            },
          })
          return
        }

        const confirmed = await confirmAction({
          title: this.$t('unitBuilder.versesQuotes.deleteConfirmTitle', {
            verse: item.verseQuoteText,
          }),
          html: this.$t('unitBuilder.versesQuotes.deleteConfirmText'),
          input: 'text',
          inputPlaceholder: this.$t('unitBuilder.versesQuotes.deleteConfirmPlaceholder'),
          inputValidator: (value) => {
            return new Promise((resolve) => {
              if (matchesConfirmWord(value, 'DELETE')) {
                resolve()
              } else {
                resolve(this.$t('unitBuilder.versesQuotes.needToTypeDelete'))
              }
            })
          },
          confirmButtonText: this.$t('unitBuilder.versesQuotes.deleteConfirmButton'),
          cancelButtonText: this.$t('unitBuilder.versesQuotes.deleteCancelButton'),
          context: this,
          buttonsStyling: false,
          customClass: {
            confirmButton:
              'swal-confirm-btn text-white text-uppercase text-body-2',
            cancelButton:
              'swal-cancel-btn text-white text-uppercase text-body-2',
          },
        })

        if (!confirmed) return

        // ✅ Proceed with delete logic
        this.versesquotes.splice(this.versesquotes.indexOf(item), 1)
        this.addToLocalStorage()
      },
      emitToParent() {
        // Emit this information to the parent component
        this.$emit('allversequotes', {
          section: this.section,
          versesquotes: this.versesquotes,
        })
      },
      onQuestionChange(item, key) {
        const statusIndicator = document.querySelectorAll(
          '.snippet-autosave-status-' + key + ', .editor-' + key
        )
        statusIndicator.forEach(function (item) {
          item.classList.add('busy')
        })

        // update localStorage
        this.addToLocalStorage()

        setTimeout(() => {
          statusIndicator.forEach(function (item) {
            item.classList.remove('busy')
          })
        }, 500)
      },
      togglePanel(index) {
        this.openedVersesQuotesPanels =
          this.openedVersesQuotesPanels === index ? null : index
      },
      updatePositions() {
        // update localStorage
        this.addToLocalStorage()
      },
      init() {
        this.versesquotes = []

        // If we have data from parent (language-specific), use that
        // Only check localStorage if we're NOT in a language-aware context (no currentLang prop)
        if (this.data && Array.isArray(this.data)) {
          // Use data prop if it's an array (even if empty)
          this.versesquotes = [...this.data]
        } else if (!this.currentLang && localStorage.getItem(this.section)) {
          // Only use localStorage for legacy support (when currentLang is not provided)
          this.versesquotes = JSON.parse(localStorage.getItem(this.section))
        } else {
          // Language-aware context with no data = empty array
          this.versesquotes = []
        }

        this.openedVersesQuotesPanels = []

        // update parent
        this.emitToParent()
      },
    },
    created() {
      this.init()
    },
  }
</script>

<style>
  .units-container .verses-quotes-container .v-expansion-panel {
    border: 1px solid #b5b5b5;
  }
  .verses-quotes-container .v-expansion-panels > div {
    width: 100%;
  }
  .verses-quotes-container .v-expansion-panel__header {
    cursor: grab;
  }
  .verses-quotes-container .response-lines .theme--light.v-messages {
    color: #000;
  }
  .verses-quotes-container .response-lines .v-label {
    font-size: 13px;
  }
  .verses-quotes-container
    .v-expansion-panels
    .snippet-autosave-status.busy
    .snippet-autosave-status_spinner-label::after {
    content: 'Preparing...';
  }
  .verses-quotes-container
    .v-expansion-panels
    .snippet-autosave-status_spinner-label::after {
    content: 'Ready!';
  }
</style>
